export const enum ASSISTANT_TYPE {
    SERVER = 'SERVER',
    LOCAL = 'LOCAL',
}

export const enum GENERATION_TYPE {
    WRITE_FULL_EMAIL = 'WRITE_FULL_EMAIL',
    SHORTEN = 'SHORTEN',
    PROOFREAD = 'PROOFREAD',
    EXPAND = 'EXPAND',
    FORMALIZE = 'FORMALIZE',
    FRIENDLY = 'FRIENDLY',
    CUSTOM_REFINE = 'CUSTOM_REFINE',
}

export const enum ERROR_TYPE {
    GENERATION_HARMFUL = 'GENERATION_HARMFUL',
    GENERATION_FAIL = 'GENERATION_FAIL',
    LOADGPU_FAIL = 'LOADGPU_FAIL',
    DOWNLOAD_FAIL = 'DOWNLOAD_FAIL',
    DOWNLOAD_REQUEST_FAIL = 'DOWNLOAD_REQUEST_FAIL',
    UNLOAD_FAIL = 'UNLOAD_FAIL',
    GENERATION_CANCEL_FAIL = 'GENERATION_CANCEL_FAIL',
    TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
    CACHING_FAILED = 'CACHING_FAILED',
    GENERATION_TOO_LONG = 'GENERATION_TOO_LONG',
}

export const enum INCOMPATIBILITY_TYPE {
    BROWSER = 'BROWSER',
    HARDWARE = 'HARDWARE',
}

export const enum GENERATION_SELECTION_TYPE {
    HAS_SELECTION = 'HAS_SELECTION',
    NO_SELECTION = 'NO_SELECTION',
}

export const enum ASSISTANT_INSERT_TYPE {
    INSERT = 'INSERT',
    REPLACE = 'REPLACE',
}
